import MedicalAssistantContainer from './medical-assistants-container';

export default MedicalAssistantContainer;
